import React, { useState } from "react";
import { createPortal } from "react-dom";
import { TooltipType } from "../types/Tooltip";
import * as TooltipR from "@radix-ui/react-tooltip";
import { InfoCircledIcon } from "@radix-ui/react-icons";
import Close from "../SVGs/Close";

const Tooltip: React.FC<TooltipType> = ({ copy }) => {
  const [open, setOpen] = useState(false);

  const tooltipOverlay = (
    <div className="tooltip__overlay pointer-coarse:fixed pointer-coarse:w-full pointer-coarse:h-[200vh] pointer-coarse:left-0 pointer-coarse:top-0 pointer-coarse:bg-sun-1000 pointer-coarse:opacity-60 pointer-coarse:group-data-[state=closed]:hidden z-[998]"></div>
  );

  return (
    <div className="tooltip">
      <TooltipR.Provider delayDuration={0}>
        <TooltipR.Root open={open} delayDuration={0} onOpenChange={setOpen}>
          <TooltipR.Trigger asChild onClick={() => setOpen(true)}>
            <div className="group icon-button flex items-center justify-center w-6 h-6">
              <InfoCircledIcon className="w-3 h-3 text-forest-700" />
              {open && createPortal(tooltipOverlay, document.body)}
            </div>
          </TooltipR.Trigger>
          <TooltipR.Portal>
            <TooltipR.Content
              side="right"
              sideOffset={0}
              collisionPadding={30}
              className="group relative z-50 pointer-coarse:flex pointer-coarse:flex-row pointer-coarse:justify-between pointer-coarse:absolute pointer-coarse:top-[50%] pointer-coarse:-translate-x-2/4 pointer-coarse:-translate-y-2/4 pointer-coarse:w-[calc(100vw-40px)] pointer-coarse:max-w-[335px] tooltip__content shadow-[0_2px_4.8px_0px_rgba(3,19,60,0.1)] max-w-[216px] p-xxxs bg-forest-900 text-white border-radius--xxs"
            >
              <span
                className="tooltip__font-set pointer-coarse:flex-[0_1_85%] self-center pointer-coarse:body--text-regular body--text-small !text-white [&>ul>li]:list-disc [&>ul>li]:-ml-6 [&>ul>li]:!text-white"
                dangerouslySetInnerHTML={{ __html: copy }}
              />
              <div
                onClick={() => setOpen(false)}
                className="tooltip__close w-[26px] h-[26px] pointer-coarse:flex items-center justify-center cursor-pointer hidden"
              >
                <Close />
              </div>
              <TooltipR.Arrow className="pointer-coarse:!hidden block tooltip-arrow w-[22px] h-[12.5px] fill-forest-900" />
            </TooltipR.Content>
          </TooltipR.Portal>
        </TooltipR.Root>
      </TooltipR.Provider>
    </div>
  );
};

export default Tooltip;
